import React from "react";

// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
import BuildIcon from "@material-ui/icons/Build";

// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";

import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

// Sections for this page
import WorkSection from "./Sections/WorkSection.js";

import styles from "assets/jss/material-kit-react/views/landingPage.js";

const useStyles = makeStyles(styles);
const TITLE = "Home | Delong.ai 🚀";

export default function LandingPage(props) {
  const classes = useStyles();
  const { ...rest } = props;


  return (
    <div>
      <Helmet>
          <title>{ TITLE }</title>
      </Helmet>
      <Header
        color="transparent"
        brand="🚀 Delong.ai"
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "white"
        }}
        {...rest}
      />
      <Parallax filter image={require("assets/img/landing-bg.jpg")}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={6}>
              <h1 className={classes.title}>Hi, I'm Drew.</h1>
              <h4>
                I'm a software engineer that obsesses over building software that solves real problems. Click the button below to see what I've been working on.
                Or browse the navigation menu above for more. 
              </h4>
              <br />
              <Link to='/projects'>
                <Button
                  color="danger"
                  size="lg"
                  rel="noopener noreferrer"
                >
                  <BuildIcon></BuildIcon>
                  &nbsp; Projects Page
                </Button>
              </Link>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>

      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <WorkSection/>
        </div>
      </div>


      <Footer />
    </div>
  );
}
